import { API_USER_SERVICE } from "../config/Constants";
import { IFirstBuildingMapDTO, ILoginDTO, ISetPasswordDTO, ISignUpDTO, IVerifyOTPDTO} from "../interfaces/User";
import { getRequest, postRequest } from "./Rest";

export const signUp = async(dto:ISignUpDTO) =>{
    const path = `${API_USER_SERVICE}/signup`;
    const response = await postRequest(path,dto);
    return response;
}
export const logIn = async(dto:ILoginDTO) => {
    const path = `${API_USER_SERVICE}/login`;
    const response = await postRequest(path,dto);
    console.log("Response signin Details: ", response);
    return response;
}
export const getUserDetails = async () => {
    const path = `${API_USER_SERVICE}/user/profile`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    console.log("Response getUserDetails : ", dataResponse);
    return dataResponse;
};
export const verifyOTP = async(dto :IVerifyOTPDTO)=>{
    const path = `${API_USER_SERVICE}/verify-otp`;
    const response = await postRequest(path, dto);
    return response;
};
export const  setNewPassword = async(dto:ISetPasswordDTO) =>{
    const path = `${API_USER_SERVICE}/user/set-password`;
    const response = await postRequest(path,dto);
    return response;
};
export const resetPassword = async(email:string) =>{
    const path = `${API_USER_SERVICE}/send-otp`;
    const response = await postRequest(path, {email: email});
    return response;
};
export const getWarehouseDetails = async() =>{
    const path = `${API_USER_SERVICE}/warehouse`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const firstMapBuilding = async (dto:IFirstBuildingMapDTO) =>{
    const path = `${API_USER_SERVICE}/buildings`;
    const response = await postRequest(path,dto);
    return response;
};
export const getFirstMapBuilding = async () =>{
    const path = `${API_USER_SERVICE}/buildings`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
